/**
 * Kako se korisnik pokazuje u izbornicima: "Ana Kovač (ana@cegrupa.com)".
 *
 * Popisi su dosad pokazivali samo e-mail, pa se osoba po imenu nije mogla
 * naci - a autocomplete pretrazuje upravo po ovom tekstu. Kad imena nema
 * (zadatak u uredivanju nosi samo id i adresu) ostaje sama adresa.
 */
export const prikazKorisnika = (u) => {
  if (!u) { return '' }
  const ime = [u.First, u.Last].filter(x => x).join(' ').trim()
  const adresa = u.email ? String(u.email) : ''
  if (ime && adresa) { return ime + ' (' + adresa + ')' }
  return ime || adresa
}

export default prikazKorisnika
